import { IErrorMessageService } from './error-message-service';
import { IHttpService } from './http-service';
import { AppConfigAnchor, HttpMethod } from './types';

export class AppConfigService {
  /** Base URL to add to all HTTP requests. */
  static readonly baseUrl = '/app-config/application-configuration-service';

  private _errorMessageService: IErrorMessageService;
  private _httpService: IHttpService;

  constructor(
    errorMessageService: IErrorMessageService,
    httpService: IHttpService
  ) {
    this._errorMessageService = errorMessageService;
    this._httpService = httpService;
  }

  /** Get all anchors for an @see AvsDesign. */
  async getAnchors(designId: string): Promise<AppConfigAnchor[]> {
    return (await this._httpService.fetchJson<AppConfigAnchor[]>({
      url: `design/${designId}/anchors`
    })).value ?? [];
  }

  /** Create an anchor for the provided @see AvsDesign. */
  async createAnchor(
    designId: string,
    anchor: Pick<AppConfigAnchor, 'name' | 'notes'>
  ): Promise<AppConfigAnchor> {
    const response = (await this._httpService.fetchJson<AppConfigAnchor>({
      body: anchor,
      method: HttpMethod.post,
      url: `design/${designId}/anchors`
    }));
    if (response.error) {
      this._errorMessageService.addError(response.error);
      throw response.error;
    }

    return response.value;
  }
}
